import { lazy } from "react";

const Clients = lazy(() => import("../pages/Clients"));
const CorporateClients = lazy(() => import("../pages/CorporateClients"));
const NaturalPersons = lazy(() => import("../pages/NaturalPersons"));
const Fop = lazy(() => import("../pages/Fop"));
const LegalPersons = lazy(() => import("../pages/LegalPersons"));
const Truckers = lazy(() => import("../pages/Truckers"));
const Trucks = lazy(() => import("../pages/Trucks"));
const TrucksTypes = lazy(() => import("../pages/TrucksTypes"));
const Trailers = lazy(() => import("../pages/Trailers"));
const TrailersTypes = lazy(() => import("../pages/TrailersTypes"));
const Payments = lazy(() => import("../pages/Payments"));
const AllOrders = lazy(() => import("../pages/AllOrders"));
const Orders = lazy(() => import("../pages/Orders"));
const Preorders = lazy(() => import("../pages/Preorders"));
const CompletedOrders = lazy(() => import("../pages/CompletedOrders"));
const Refuellings = lazy(() => import("../pages/Refuellings"));
const Products = lazy(() => import("../pages/Products"));
const Delivery = lazy(() => import("../pages/Delivery"));
const OilStorage = lazy(() => import("../pages/OilStorage"));
const FeedbackForms = lazy(() => import("../pages/FeedbackForms"));
const SomethingWentWrong = lazy(() => import("../pages/SomethingWentWrong"));
const DeliveryRequests = lazy(() => import("../pages/DeliveryRequests"));
const CanceledByDriver = lazy(() => import("../pages/CanceledByDriver"));
const CanceledBySystem = lazy(() => import("../pages/CanceledBySystem"));
const InfoMessages = lazy(() => import("../pages/InfoMessages"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Parties = lazy(() => import("../pages/Parties"));
const FuelReport = lazy(() => import("../pages/FuelReport"));
const BalanceReport = lazy(() => import("../pages/BalanceReport"));
const FreeDelivery = lazy(() => import("../pages/FreeDelivery"));
const FuelDiscounts = lazy(() => import("../pages/FuelDiscounts"));
const Roles = lazy(() => import("../pages/Roles"));
const Admins = lazy(() => import("../pages/Admins"));
const Regions = lazy(() => import("../pages/Regions"));
const Banners = lazy(() => import("../pages/Banners"));
const Analytics = lazy(() => import("../pages/Analytics"));

interface IRoutes {
  path: string;
  element: JSX.Element;
  isPrivate: boolean;
  permissionKey: string;
}

export const routes: IRoutes[] = [
  {
    path: "/",
    element: <Clients />,
    isPrivate: true,
    permissionKey: "CLIENTS_READ",
  },
  {
    path: "/natural-persons",
    element: <NaturalPersons />,
    isPrivate: true,
    permissionKey: "CLIENTS_READ",
  },
  {
    path: "/fop",
    element: <Fop />,
    isPrivate: true,
    permissionKey: "CLIENTS_READ",
  },
  {
    path: "/legal-persons",
    element: <LegalPersons />,
    isPrivate: true,
    permissionKey: "CLIENTS_READ",
  },
  {
    path: "/corporate-clients",
    element: <CorporateClients />,
    isPrivate: true,
    permissionKey: "CLIENTS_READ",
  },
  {
    path: "/truckers",
    element: <Truckers />,
    isPrivate: true,
    permissionKey: "TRUCKERS_READ",
  },
  {
    path: "/tractors",
    element: <Trucks />,
    isPrivate: true,
    permissionKey: "TRUCKS_READ",
  },
  {
    path: "/trucks",
    element: <Trucks />,
    isPrivate: true,
    permissionKey: "TRUCKS_READ",
  },
  {
    path: "/trucks-types",
    element: <TrucksTypes />,
    isPrivate: true,
    permissionKey: "SETTINGS_READ",
  },
  {
    path: "/trailers",
    element: <Trailers />,
    isPrivate: true,
    permissionKey: "TRUCKS_READ",
  },
  {
    path: "/trailers-types",
    element: <TrailersTypes />,
    isPrivate: true,
    permissionKey: "SETTINGS_READ",
  },
  {
    path: "/payments",
    element: <Payments />,
    isPrivate: true,
    permissionKey: "PAYMENTS_READ",
  },
  {
    path: "/all-orders",
    element: <AllOrders />,
    isPrivate: true,
    permissionKey: "ORDERS_READ",
  },
  {
    path: "/orders",
    element: <Orders />,
    isPrivate: true,
    permissionKey: "ORDERS_READ",
  },
  {
    path: "/preorders",
    element: <Preorders />,
    isPrivate: true,
    permissionKey: "ORDERS_READ",
  },
  {
    path: "/completed-orders",
    element: <CompletedOrders />,
    isPrivate: true,
    permissionKey: "ORDERS_READ",
  },
  {
    path: "/refuellings",
    element: <Refuellings />,
    isPrivate: true,
    permissionKey: "REFUELLINGS_READ",
  },
  {
    path: "/parties",
    element: <Parties />,
    isPrivate: true,
    permissionKey: "PARTIES_READ",
  },
  {
    path: "/products",
    element: <Products />,
    isPrivate: true,
    permissionKey: "SETTINGS_READ",
  },
  {
    path: "/delivery",
    element: <Delivery />,
    isPrivate: true,
    permissionKey: "SETTINGS_READ",
  },
  {
    path: "/oil-storage",
    element: <OilStorage />,
    isPrivate: true,
    permissionKey: "SETTINGS_READ",
  },
  {
    path: "/feedback-forms",
    element: <FeedbackForms />,
    isPrivate: true,
    permissionKey: "NOTIFICATIONS_READ",
  },
  {
    path: "/something-went-wrong",
    element: <SomethingWentWrong />,
    isPrivate: true,
    permissionKey: "NOTIFICATIONS_READ",
  },
  {
    path: "/delivery-requests",
    element: <DeliveryRequests />,
    isPrivate: true,
    permissionKey: "NOTIFICATIONS_READ",
  },
  {
    path: "/canceled-by-driver",
    element: <CanceledByDriver />,
    isPrivate: true,
    permissionKey: "NOTIFICATIONS_READ",
  },
  {
    path: "/canceled-by-system",
    element: <CanceledBySystem />,
    isPrivate: true,
    permissionKey: "NOTIFICATIONS_READ",
  },
  {
    path: "/info-messages",
    element: <InfoMessages />,
    isPrivate: true,
    permissionKey: "NOTIFICATIONS_READ",
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    isPrivate: true,
    permissionKey: "DASHBOARD_READ",
  },
  {
    path: "/fuel-report",
    element: <FuelReport />,
    isPrivate: true,
    permissionKey: "REPORTS_READ",
  },
  {
    path: "/balance-report",
    element: <BalanceReport />,
    isPrivate: true,
    permissionKey: "REPORTS_READ",
  },
  {
    path: "/free-delivery",
    element: <FreeDelivery />,
    isPrivate: true,
    permissionKey: "PROMOTIONS_READ",
  },
  {
    path: "/fuel-discounts",
    element: <FuelDiscounts />,
    isPrivate: true,
    permissionKey: "PROMOTIONS_READ",
  },
  {
    path: "/roles",
    element: <Roles />,
    isPrivate: true,
    permissionKey: "ADMIN_ROLES_READ",
  },
  {
    path: "/admins",
    element: <Admins />,
    isPrivate: true,
    permissionKey: "ADMINS_READ",
  },
  {
    path: "/regions",
    element: <Regions />,
    isPrivate: true,
    permissionKey: "REGIONS_READ",
  },
  {
    path: "/banners",
    element: <Banners />,
    isPrivate: true,
    permissionKey: "BANNERS_READ",
  },
  {
    path: "/analytics",
    element: <Analytics />,
    isPrivate: true,
    permissionKey: "ORDERS_READ",
  },
];
